<button [class.loading]="loading" [disabled]="disabled" [ngClass]="[sizeClass, typeClass, iconSize]" class="button">
  @if (loading) {
    <ui-loader [showSpinner]="true" color="dark" size="m"></ui-loader>
  } @else {
    <svg-icon [src]="iconPath"></svg-icon>
  }
</button>
